<style lang="less" scoped>
  .in-sec {
    width: 1200px; margin: 0 auto;
    text-align: center; padding: 79px 0 160px 0;
  }
  h2 {
    margin: 0 auto; line-height: 60px; display: inline-block;
    border: 2px solid #8cf7fb; font-family: 'DINPro-B'; font-size: 26px;
    padding: 0 53px; border-radius: 32px; background-color: #fff;
    box-shadow: 0 5px 10px rgba(51, 55, 64, .09);
  }
  .sec { text-align: left; padding-top: 52px; }
  dl {
    text-align: left; padding-left: 170px; vertical-align: top;
    position: relative; width: 50%; display: inline-block;
    dt {
      font-size: 24px; color: #8f8f9c; font-family: 'DINPro-L';
      display: inline-block; position: absolute; left: 0; top: 7px;
    }
    dd {
      text-align: left; padding: 0; margin: 0; line-height: 240%;
      span {
        font-size: 17px; color: #1170fe; font-family: 'DINPro-L';
        padding-right: 26px;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .in-sec {
      width: 100%; padding: 40px 0;
    }
    h2 {
      font-size: 13px; line-height: 30px; border-radius: 15px;
      padding: 0 25px;
    }
    .sec { padding-top: 26px; }
    dl {
      padding-left: 20px;
      position: relative; width: 100%; display: block;
      dt {
        font-size: 12px; padding-bottom: 15px;
        display: block; position: relative;
      }
      dd {
        text-align: left; padding: 0; margin: 0; line-height: 240%; font-size: 10px;
        span {
          font-size: 10px; color: #1170fe; font-family: 'DINPro-L';
          padding-right: 13px;
        }
      }
    }
  }
</style>

<template lang="pug">
  .history-container
    .in-sec
      h2 HISTORY
      .sec
        dl(v-for=("history in histories"))
          dt {{ history.title }}
          dd(v-for=("item in history.rows")) #[span {{ item.year }}] {{ item.text }}
</template>

<script>
export default {
  props: {
    histories: Array,
    default: null,
  },
};
</script>
